module.exports = __webpack_public_path__ + "static/media/delpotro.4c0fb03a.jpg";